var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-login.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-button";
import "@adornis/chemistry/elements/components/x-flex";
import { AdornisUser } from "@adornis/users/db/a-user";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { filter, firstValueFrom } from "rxjs";
import "../forms/x-input";
import "./x-login-input";
var ElementsLogin = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.errorMessage = "";
    this["header-src"] = "https://static.adornis.de/logo.svg";
    this.userClass = AdornisUser;
  }
  styles() {
    return { ":host": { display: "block" } };
  }
  firstUpdated() {
    const emailInput = document.createElement("x-login-input");
    emailInput.setAttribute("type", "email");
    emailInput.setAttribute("placeholder", "Username/Email");
    emailInput.addEventListener("value-changed", (e) => this._email = e.detail.value);
    emailInput.addEventListener("submit", () => this.login());
    const passwordInput = document.createElement("x-login-input");
    passwordInput.setAttribute("type", "password");
    passwordInput.setAttribute("placeholder", "Password");
    passwordInput.addEventListener("value-changed", (e) => this._password = e.detail.value);
    passwordInput.addEventListener("submit", () => this.login());
    this.appendChild(emailInput);
    this.appendChild(passwordInput);
  }
  async login() {
    this.errorMessage = "";
    if (!this._email?.length || !this._password?.length) {
      this.errorMessage = "Die Eingaben d\xFCrfen nicht leer sein!";
      return;
    }
    await this.userClass.login(this._email, this._password).then(() => firstValueFrom(this.userClass.currentUser.whenReady.pipe(filter(Boolean)))).catch((e) => this.errorMessage = `Fehler beim Einloggen: ${e.message}`);
    this.dispatchEvent(new CustomEvent("login"));
  }
  render() {
    return html`
      <x-flex center crossaxis-center ${css({ height: "100%" })}>
        <x-flex space="md" ${css({ width: this.sizes.maxReadableWidth })}>
          ${this["header-src"] ? html`
                <x-flex crossaxis-center>
                  <img src=${this["header-src"]} alt="Logo" ${css({ maxWidth: "200px" })} />
                </x-flex>
              ` : nothing}
          <slot></slot>
          ${this.errorMessage ? html` <x-text align="center" tone="error"> ${this.errorMessage} </x-text> ` : nothing}
          <x-button @click=${() => this.login()}> Login </x-button>
        </x-flex>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], ElementsLogin.prototype, "errorMessage", 2);
__decorateClass([
  property()
], ElementsLogin.prototype, "header-src", 2);
ElementsLogin = __decorateClass([
  customElement("x-login")
], ElementsLogin);
export {
  ElementsLogin
};
